const moment = require('moment');

module.exports = {
  install: function(Vue, parameters) {
    Vue.prototype.$format = {
      ago(date) {
        return moment(date).fromNow();        
      },
      date(date) {
        return moment(date).format('DD.MM.YYYY HH:mm');
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/format.js